document.addEventListener("DOMContentLoaded", function(e) {
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutationRecord) {

			let step_container = document.getElementsByClassName('ff-step-body')[0];
			
			if(step_container) {
				let offset = step_container.style.left;

				if(["0%", "-100%", "-200%", "-300%", "-400%", "-500%", "-600%", "-700%"].includes(offset)) {
					setTimeout(function() {
						window.scroll({
							behavior: 'smooth',
							left: 0,
							top: 0
						});
					}, 500);
				}
			}
		});    
	});
		
	try {
		observer.observe(document.querySelector('.ff-step-body'), { attributes : true, attributeFilter : ['style'] });
	} catch(e) {
	}
});